<!-- <a  matTooltip="{{this.translate.data['TOOLTIPEDITPLATFORMGROUPROLE'] | translate}}"  [routerLink]="routerLinkEditPlatformGroupRole">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_edit}}</mat-icon>
</a> -->
<!-- <a matTooltip="{{this.translate.data['TOOLTIPVIEWTENANTGROUPROLEPERMISSIONS'] | translate}}" (click)="viewTenantPermissions()">
  <mat-icon aria-hidden="false" aria-label="icon">{{icon_view}}</mat-icon>
</a>
<a matTooltip="{{this.translate.data['TOOLTIPDELETETENANTGROUPROLE'] | translate}}" (click)="deleteTenantGroupRole()">
  <mat-icon aria-hidden="false" aria-label="icon">{{icon_delete}}</mat-icon>
</a> -->
<a>
  <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" (click)="viewProjectPermissions()">Berechtigungen</button>
</a>
<a>
  <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" (click)="deleteProjectGroupRole()">Löschen</button>
</a>

